import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Rincón de la Victoria"
      slug="rincon-de-la-victoria"
      poblacion={48000}
      lat={36.7167}
      lng={-4.2833}
      neighborhoodsText="Cubrimos todo Rincón de la Victoria, La Cala del Moral y Torre de Benagalbón. Atendemos el centro, Benagalbón, Añoreta y las nuevas urbanizaciones del litoral oriental."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Rincón de la Victoria?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Rincón de la Victoria?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}